<ul class="primary-menu">
  @for (menuItem of menuItems; track menuItem) { @if (menuItem | displayWithAuth : authInfor()) {
  <li>
    @if (!menuItem?.link?.is_external) {
    <a [appNavigateToUrl]="menuItem?.link?.url || menuItem?.url">
      {{ menuItem?.link?.label || menuItem?.label }}
      @if (menuItem?.link?.icon || menuItem?.icon) {
      <i [ngClass]="'fa fa-' + (menuItem?.link?.icon || menuItem?.icon)" aria-hidden="true"></i>
      }
    </a>
    } @if (menuItem?.link?.is_external) {
    <a [href]="menuItem?.link?.url || menuItem?.url">
      {{ menuItem?.link?.label || menuItem?.label }}
      @if (menuItem?.link?.icon || menuItem?.icon) {
      <i [ngClass]="'fa fa-' + (menuItem?.link?.icon || menuItem?.icon)" aria-hidden="true"></i>
      }
    </a>
    } @if (menuItem?.items?.length) {
    <app-sub-menu [items]="menuItem?.items"></app-sub-menu>
    }
  </li>
  } }
</ul>
